import { store } from '../../../store';
import { toggleStatus } from '../../../store/conversation/conversation.slice';

export const handleToggleStatus = (question) => {
  store.dispatch(toggleStatus(question));
};
